function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.707 12.292a3 3 0 11-1.414 1.414l-3.75-3.749a1 1 0 011.414-1.414l3.75 3.75zM12 3c6.628 0 12 5.373 12 12 0 2.186-.588 4.235-1.61 6H1.61A11.937 11.937 0 010 15C0 8.373 5.372 3 12 3zm0 2C6.486 5 2 9.486 2 15c0 1.38.287 2.744.836 4h18.329A9.998 9.998 0 0022 15c0-5.514-4.486-10-10-10zm0 9a1.001 1.001 0 000 2 1.001 1.001 0 000-2z"
  }));
}
export default SvgIconDashboard;